export enum UpdateOperation {
  SAVE,
  DELETE,
  NONE,
}
